import { createSelector } from 'reselect'
import { featureStateSelector } from './featureStateSelector'

export const userStateSelector = createSelector(featureStateSelector, (state) => state.user)

export default userStateSelector
